import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AfterloginHeader from "./Component/AfterLoginHeader/AfterLoginHeader";
import Loginform from "./Pages/LoginPage";
import { useSelector } from "react-redux";
import Adminconsole from "./Component/AdminConsole/Adminconsole";
function RoutePage() {
  const isLoggedIn = useSelector((state) => state.userDetails.isLoggedIn);

  return (
    <Router>
      {isLoggedIn ? <AfterloginHeader /> : ""}
      <Routes>
        <Route path="/" index element={<Loginform />} />
        <Route path="/AdminConsole" index element={<Adminconsole />} />
      </Routes>
    </Router>
  );
}

export default RoutePage;
